const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Record identifiers are not analytics dimensions, and on public pages the reschedule URL's
 * meeting id would otherwise leave the app with every page view.
 *
 * Shared because both the Amplitude enrichment plugin in `apps/web` and the attribution capture
 * (which runs on `apps/www` too) have to redact the same path segments the same way.
 */
export const redactPathIds = (pathname: string): string => {
  return pathname
    .split('/')
    .map((segment) => {
      return UUID_SEGMENT.test(segment) ? ':id' : segment;
    })
    .join('/');
};
